import React, { Component } from 'react';

import './PublicModal.css';

class PublicModal extends Component {
  render() {
    let classNames = ['PublicModal'];
    if (this.props.centered) {
      classNames.push('PublicModal--centered');
    }

    return (
      <div className={classNames.join(' ')}>
        <div className="PublicModal__content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default PublicModal;



// WEBPACK FOOTER //
// ./src/components/PublicModal.js